<template>
  <!--表单组件模板-->
  <!--暂时没有封装-->
  <!--使用的时候复制代码到需要使用的地方，修改相应的参数进行使用-->
  <div class="formMsg">
    <el-form-item v-for="(item,index) in formItem" :label="item.label" :key="item.name"  v-if="item.type !== 3" :prop="item.name">
      <el-input v-if="item.type === 0" :name="item.name" v-model="item.value" @blur="item.blur(index)" @change="item.changes(index)" @focus="item.focus(index)" clearable></el-input>
      <div v-if="item.warning === 1" style="position: absolute;margin-top: -10px;margin-left: 5px;color: red;" v-html="item.warningMsg"></div>
      <el-select v-if="item.type === 1"  :name="item.name" v-model="item.value" @blur="item.blur(index)" @change="item.changes(index)" @focus="item.focus(index)" :placeholder="item.placeholder" clearable >
        <el-option v-for="it in item.options" :key="it.value" :label="it.label" :value="it.label"></el-option>
      </el-select>
      <div v-if="item.warning === 1" style="position: absolute;margin-top: -10px;margin-left: 5px;color: red;">{{item.warningMsg}}</div>
    </el-form-item>
  </div>
</template>

<script>
  export default {
    name: "form",
    data() {
      return {
        /**
         * 表单渲染数组
         * @label 标签头
         * @value 双向绑定的值
         * @placeholder 提示值
         * @name  校验规则插槽名，key名，form表单获取名
         * type  类型（0：input，1：select，3：不显示）
         * @changes 值改变时的回调函数
         * @options 下拉框时的下拉菜单的值
         */
        /*form:[
          {label:"test1",value:'',placeholder:"test1",name:"test1",type:0,warning:0,warningMsg:"",readonly:true,
            focus:((index)=>{

            }),
            blurs:((index)=>{

            }),
            changes:((index)=>{
              console.log(this.form[index].value);
              if(this.form[index].value === "1"){
                this.form[1].type = 3;
              }
              else{
                this.form[1].type = 0;
              }
            }),options:[
              {}
            ]
          },
          {label:"test2",value:'',placeholder:"test2",name:"test2",type:0,warning:0,warningMsg:"",readonly:true,
            focus:((index)=>{

            }),
            blurs:((index)=>{

            }),
            changes:((index)=>{
              console.log(this.form[index].value);
              if(this.form[index].value === "1"){
                this.form[1].type = 3;
              }
              else{
                this.form[1].type = 0;
              }
            }),options:[
              {}
            ]
          },
          {label:"test3",value:'',placeholder:"",name:"test3",type:1,warning:0,warningMsg:"",readonly:true,
            focus:((index)=>{

            }),
            blurs:((index)=>{

            }),
            changes:((index)=>{
              console.log(this.form[index].value);
              if(this.form[index].value === "1"){
                this.form[1].type = 3;
              }
              else{
                this.form[1].type = 0;
              }
            }),options: [
              {label:"test",value:"2"},
              {label:"test1",value:"21"},
              {label:"test2",value:"23"},
            ]
          },
          {label:"test4",value:'',placeholder:"",name:"test4",type:1,warning:0,warningMsg:"",readonly:true,
            focus:((index)=>{

            }),
            blurs:((index)=>{

            }),
            changes:((index)=>{
              console.log(this.form[index].value);
              if(this.form[index].value === "1"){
                this.form[1].type = 3;
              }
              else{
                this.form[1].type = 0;
              }
            }),options: [
              {label:"test",value:"2"},
              {label:"test1",value:"21"},
              {label:"test2",value:"23"},
            ]
          }
        ],*/
      }
    },
    props:{
      formItem:{
        type: Array,
        default:[]
      }
    }
  }
</script>

<style scoped>
  .el-form-item {
    width: 33%;
  }

  .el-form-item__content {
    width: calc(100% - 45%);
  }

  .el-input {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/assets/components/form.vue